import React from 'react'

function Copyright() {
    return (
        <>
        <div className='bg-[#ffff] py-4 px-8'>
       <h4 className='text-[15px] font-semibold text-gray-700'>Copyright 2024 ©</h4>
        </div>
        </>
    )
}

export default Copyright
